import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Box } from 'carbon-react/lib/components/box/box.component';

import { getDashboardsUrl } from '@futrli/shared-services';
import { ListingPageTabs } from '@futrli/ui-components/components/listing-page/listing-page-tabs/listing-page-tabs';

import { useNavHeight } from '../../../hooks/useNavHeight';
import { PerformanceDashboardsTab } from './performance-dashboards/performance-dashboards-tab';
import { MyDashboardsTab } from './my-dashboards/my-dashboards-tab';
import { DashboardTemplatesTab } from './dashboard-templates/dashboard-templates-tab';

export enum DashboardsTabId {
  PERFORMANCE_DASHBOARDS = 'performance-dashboards',
  DASHBOARDS_LIST = 'dashboards-list',
  DASHBOARD_TEMPLATES = 'dashboard-templates'
}

export const DashboardsTabs = () => {
  const intl = useIntl();
  const { navHeight } = useNavHeight();
  const { workspaceId = '', organisationId = '' } = useParams();
  const basePath = getDashboardsUrl(workspaceId, organisationId);

  const tabs = useMemo(() => {
    return [
      {
        id: DashboardsTabId.PERFORMANCE_DASHBOARDS,
        title: intl.formatMessage({
          id: 'predict.dashboards.performance_dashboards',
          defaultMessage: 'Performance dashboards'
        }),
        component: <PerformanceDashboardsTab />
      },
      {
        id: DashboardsTabId.DASHBOARDS_LIST,
        title: intl.formatMessage({
          id: 'predict.dashboards.dashboards_list',
          defaultMessage: 'Dashboards list'
        }),
        component: <MyDashboardsTab />
      },
      {
        id: DashboardsTabId.DASHBOARD_TEMPLATES,
        title: intl.formatMessage({
          id: 'predict.dashboards.dashboard_templates',
          defaultMessage: 'Dashboard templates'
        }),
        component: <DashboardTemplatesTab />
      }
    ];
  }, [intl]);

  return (
    <Box mt={3}>
      <ListingPageTabs stickyTop={navHeight} tabs={tabs} basePath={basePath} mountActiveTabOnly />
    </Box>
  );
};
